export enum OldJobEditorTab {
  JobPosting = 'job_posting',
  ApplicationForm = 'application_form',
  Workflow = 'workflow',
  Team = 'team',
  Referrals = 'referrals',
  Requisition = 'requisition',
  SocialMedia = 'social-media',
}

export enum JobEditorDialogTab {
  JobDetails = 'job_details',
  Application = 'application',
  Process = 'process',
  Team = 'team',
  Referrals = 'referrals',
  SocialSharing = 'social_sharing',
}

export const JobEditorDialogPathsMap: Record<JobEditorDialogTab, string> = {
  [JobEditorDialogTab.JobDetails]: 'job_details',
  [JobEditorDialogTab.Application]: 'application',
  [JobEditorDialogTab.Process]: 'process',
  [JobEditorDialogTab.Team]: 'team',
  [JobEditorDialogTab.Referrals]: 'referrals',
  [JobEditorDialogTab.SocialSharing]: 'social_sharing',
};

export const OldJobEditorPathsMap: Record<OldJobEditorTab, string> = {
  [OldJobEditorTab.JobPosting]: '../edit',
  [OldJobEditorTab.ApplicationForm]: 'application_form',
  [OldJobEditorTab.Workflow]: 'hiring_funnel',
  [OldJobEditorTab.Team]: 'recruiting_team',
  [OldJobEditorTab.Referrals]: 'referrals',
  [OldJobEditorTab.Requisition]: 'requisition',
  [OldJobEditorTab.SocialMedia]: 'social-media',
};

export enum InsertFromTemplateMethod {
  NotOverride = 'missing_fields',
  Override = 'all',
}
